/**
 * Borang "Paid renewal" (popup Extend days, 2026-10-14): RM + tarikh bayar → { paidSen, paidAt }
 * untuk server. Pelanggan bayar di luar sistem (transfer), admin rekod resit + tambah hari sekali gus.
 *
 * ⚠️ KEMBAR: functions/flowResitManual.js semakBayaranManual — server sumber kebenaran; ini hanya
 *    supaya admin nampak ralat sebelum menghantar (had + ayat sama).
 */
const DAY_MS = 24 * 60 * 60 * 1000;
export const HAD_SEN_MAX = 1_000_000;

/** "100" / "RM100" / "99.50" → sen (integer). Kosong / rosak → NaN. */
export function senDariRm(teks) {
    const s = String(teks ?? '').trim();
    if (s === '') return NaN;
    const n = Number(s.replace(/[^\d.]/g, ''));
    return Number.isFinite(n) ? Math.round(n * 100) : NaN;
}

/** 'YYYY-MM-DD' ikut hari Malaysia (untuk nilai lalai kotak tarikh). */
export const hariIniMY = () => new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Kuala_Lumpur' });

/**
 * @returns {{ ok: true, paidSen: number, paidAt: number } | { ok: false, ralat: string }}
 */
export function semakBayaranManual({ rmTeks, tarikhTeks, now = Date.now() }) {
    const paidSen = senDariRm(rmTeks);
    if (!Number.isSafeInteger(paidSen) || paidSen < 1 || paidSen > HAD_SEN_MAX) {
        return { ok: false, ralat: 'Enter the amount paid (RM0.01–RM10,000).' };
    }
    if (!/^\d{4}-\d{2}-\d{2}$/.test(String(tarikhTeks || ''))) return { ok: false, ralat: 'Pick the payment date.' };
    // Tengah hari MY → hari yang sama walau apa zon waktu browser admin (corak setTarikhFlow).
    const paidAt = new Date(`${tarikhTeks}T12:00:00+08:00`).getTime();
    if (!Number.isSafeInteger(paidAt) || paidAt < now - 365 * DAY_MS || paidAt > now + DAY_MS) {
        return { ok: false, ralat: 'Pick the payment date — within the last year, not in the future.' };
    }
    return { ok: true, paidSen, paidAt };
}
